<template>
    <modal ref="modal" body-class="px-2 px-lg-5" dialog-class="modal-lg">
        <h4 class="text-center mb-4">Please select your move date</h4>

    
        <date-picker class="inline-block h-full" v-model="date" is-expanded color="green"  :attributes='attrs' >
            <template v-slot="{ inputValue, togglePopover }">
                <button class="btn btn-lg btn-block border choose-date"
                        @click="togglePopover({ placement: 'auto-start' })">
                    <span class="float-left" v-if="inputValue"><i
                        class="fa fa-calendar mr-auto"></i> {{ inputValue | date }}</span>
                    <span class="float-left" v-else>Choose date</span>
                    <span class="float-right">
                        <i class="fa fa-angle-down"></i>
                    </span>
                </button>
            </template>
        </date-picker>
        <div class="card my-4" v-if="date && !isInTheFuture">
            <div class="card-body">
                Please provide information about your new home and energy supply, so MySwitchPro can find the best deal for you and continue saving money.
            </div>
        </div>

        <address-locator v-if="date && !isInTheFuture" @selected="onAddressSelected" />

        <div class="card my-4" v-if="date && isInTheFuture">
            <div class="card-body">
                As soon as you have completed your move, please log into your MySwitchPro dashboard and update your new home energy supply information.
            </div>
        </div>
        <button class="btn btn-success btn-success-gradient btn-lg px-5 mt-4 float-right" @click="$refs.modal.hide()">Ok</button>
    </modal>
</template>

<script>
import Modal from "../Modal";
import AddressLocator from "../AddressLocator";
import ClearStoreMixin from "@/mixins/ClearStoreMixin";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

let moment = require('moment');
    export default {
        name: "MoveModal",
        components: {AddressLocator, Modal, DatePicker},
        mixins: [ClearStoreMixin],
        data: () => {
            return {
                date: null,
                openDatepicker: false,
                address: null,
                attrs: [
                    {
                        key: 'today',
                        highlight: {
                            fillMode: 'outline',
                        },
                        dates: new Date(),
                    },
                ],
            }
        },
        computed: {
            isInTheFuture:  function (){
                return moment().isBefore(this.date)
            }
        },
        filters: {
            date: function (date) {
                return moment(date).format('ddd, MMMM Do, YYYY')
            }
        },
        methods: {
            show() {
                this.$refs.modal.show();
            },
            hide() {
                this.$refs.modal.hide();
            },
            onAddressSelected: function (address) {
                this.clearStore();
                this.$store.commit('setup/setAddress', address);
                this.$router.push({name: 'SetupHome' });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";


    ::v-deep {
        $vdpColor: #18A0FB;
        
        .choose-date {
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #F3F3F3 100%);
        }

        .vdpComponent {
            width: 100%;
        }
        .vdpOuterWrap {
            right: 0;
        }
        .vdpFloating .vdpInnerWrap {
            max-width: none;
        }
    }
</style>
